import { render, staticRenderFns } from "./_microgaming.vue?vue&type=template&id=443b55e8&lang=pug&"
import script from "./_microgaming.vue?vue&type=script&lang=js&"
export * from "./_microgaming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports